export default __webpack_public_path__ + "static/media/Tiěshānkào.19839f89.png";